<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-menu
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="contextModel"
        max-width="290px"
        min-width="290px"
        offset-y
        ref="menu"
        transition="scale-transition"
        v-model="contextDialog"
      >
        <template #activator="{on}">
          <v-text-field v-on="on" :label="label" :placeholder="placeholder" :prepend-icon="prependIcon" readonly v-model="contextModel" />
        </template>
        <v-time-picker @click:minute="$refs.menu.save(contextModel)" format="24hr" full-width v-if="contextDialog" v-model="contextModel" />
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "TimePicker",
  props: {
    label: {
      required: true,
      type: String
    },
    placeholder: {
      required: false,
      type: String,
      default: null
    },
    model: {
      required: true
    },
    prependIcon: {
      required: false,
      default: "access_time"
    },
    dialog: {
      required: false,
      default: null
    }
  },
  data() {
    return {
      timeDialog: false
    };
  },
  computed: {
    contextModel: {
      get() {
        return this.model;
      },
      set(value) {
        this.$emit("update:model", value);
      }
    },
    contextDialog: {
      set(value) {
        if (this.dialog == null) {
          this.timeDialog = value;
        } else {
          this.$emit("update:dialog", value);
        }
      },
      get() {
        if (this.dialog != null) return this.dialog;
        return this.timeDialog;
      }
    }
  }
};
</script>

<style scoped></style>
